import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { translate } from '../../../i18n';
import { CoachingSessionDto } from '../../../models/coach/dto/coaching-session.dto';
import { COACHING_SESSION_QUERY_KEY } from './useGetCoachingSession';

export const useCancelCoachingSession = () => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async (coachingSessionId: string) => {
            return apiClient.fetchApi<CoachingSessionDto, {}>({
                endpoint: `coachs/coaching-sessions/${coachingSessionId}/cancel`,
                method: 'POST',
                body: {},
            });
        },
        onSuccess: (data, coachingSessionId) => {
            toast({
                title: translate('coaching_session.canceled_successfully'),
                description: translate('coaching_session.session_has_been_canceled_refunds_processed'),
                status: 'success',
                duration: 5000,
                isClosable: true,
            });

            // Invalidate and refetch coaching session details to update the UI
            queryClient.invalidateQueries({ queryKey: COACHING_SESSION_QUERY_KEY(coachingSessionId) });
        },
        onError: (error: any) => {
            toast({
                title: translate('coaching_session.error_canceling_session'),
                description: error?.message || translate('common.unexpected_error'),
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        },
    });
};
